class AddressListController implements angular.IOnInit {
  public addresses: { address: string, selected: boolean }[];
  public searchText: string;

  private addressesOriginal: { [address: string]: boolean } = {};

  /** @ngInject */
  constructor(private $mdDialog: angular.material.IDialogService) { }

  $onInit(): void {
    this.addressesOriginal = this.addresses.reduce((prev, curr) => {
      prev[curr.address] = curr.selected;
      return prev;
    }, {});
  }

  public save() {
    this.$mdDialog.hide();
  }

  public cancel() {
    this.addresses.forEach(a => a.selected = this.addressesOriginal[a.address]);
    this.$mdDialog.cancel();
  }
}

export const AddressListDialog: angular.IComponentOptions = {
  controller: AddressListController,
  template: require('./addressList.dialog.html'),
  bindings: {
    addresses: '<'
  }
}



// WEBPACK FOOTER //
// ./src/app/bulkemailing/components/addressList.dialog.ts